import styled from 'styled-components'
import { BodyDefault, BodySmall, VerySmall } from '../typography/styled';

type SelectProps = {
  active:boolean;
  isSelectedValue:boolean;
  isSmall?:boolean;
  disabled?:boolean;
  multi?:boolean;
  error?:boolean;
  isRegion?:boolean;
}

type ActiveProp = {
  active?:boolean;
  isSmall?:boolean;
  $disabled?:boolean;
  $checked?:boolean;
}
type DataWrapperProps = { 
  isSmall?:boolean;
  isRegion?:boolean;
  customStyles?:any;
  height?:any;
  multi?:boolean;
}
type FlavorTypeItem = {
  block?:boolean
}
export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'customStyles',
})<DataWrapperProps>`
  position: relative;
  /* display: flex;
  flex-direction: column; */
  /* height:100%; */
  ${({customStyles}) => customStyles}

  @media (max-width: 768px) {
    ${({isRegion}) => !isRegion && `
      width: 100%;
      min-width: 0;
      max-width: 100%;
    `}
  }
`
export const ToolTipImg = styled.img`
  margin-left:4px;
  &:hover{
    cursor: pointer;
  }
`
export const DropDown = styled.div.withConfig({
  shouldForwardProp: (prop) => !['active', 'isSelectedValue', 'isSmall', 'disabled', 'multi', 'error', 'isRegion'].includes(prop),
})<SelectProps>`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: ${({isRegion}) => isRegion ? '' : 'center'};
  flex-direction:${({isRegion}) => isRegion ? 'column' : ''};
  /* flex-wrap:wrap; */
  width: 100%;
  max-height:${({multi, isSmall}) =>  multi ? '' : isSmall ? '24px' : '40px'};
  min-height: ${({isSmall}) => isSmall ? '24px' : '40px'};
  background-color: ${({theme, disabled}) => disabled ? theme.palette[200] : theme.palette[10]};
  padding: ${({isSmall, multi, isRegion}) => isRegion ? '4px 8px 4px 10px' : multi ? '4px 10px' : isSmall ? '1px 4px 1px 6px' : '12px 8px 12px 10px'};

  border: ${({theme, active, disabled, error}) => disabled ? `1px solid ${theme.grey[350]}` : error ? `1px solid ${theme.errors[600]}` : active ? `1px solid ${theme.accent[100]}` : `1px solid ${theme.grey[350]}`};
  box-shadow: ${({active, theme, disabled, error, isRegion}) => disabled ? '' : active ? error ? theme.isDark ? theme.shadows.errorFocusDark : theme.shadows.errorFocus : theme.isDark ? theme.shadows.focusDark : theme.shadows.focus : isRegion ? theme.shadows.card : ''};
  border-radius: ${({theme, isSmall}) => isSmall ? theme.radius.xs : theme.radius.search};
  color: ${({theme, isSelectedValue}) => isSelectedValue ? theme.palette[900] : theme.grey[600]};
  &:hover{
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    color: ${({theme, disabled}) => disabled ? theme.grey[600] : theme.grey[900]};
  }
  &:target{
    /* box-shadow: ${({disabled}) => disabled ? '' : '0px 0px 0px 3px #E0EAFF'}; */
    border: ${({theme, error}) => error ? `1px solid ${theme.errors[600]}` : `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme, error}) => error ? theme.isDark ? theme.shadows.errorFocusDark : theme.shadows.errorFocus : theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &:focus-visible{
    outline: none;
    border: ${({theme, error}) => error ? `1px solid ${theme.errors[600]}` : `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme, error}) => error ? theme.isDark ? theme.shadows.errorFocusDark : theme.shadows.errorFocus : theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const ImgArrow = styled.img.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<ActiveProp>`
  transform: ${({active}) => active ? 'rotate(180deg)' : ''};
  transition:0.2s transform ease-in-out;
  opacity: ${({$disabled}) => $disabled ? '0.45' : '1'};
  flex: 0 0 auto;
`

export const ControlContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
`

export const SelectedValue = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
`

export const SelectActions = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
`

export const OptionsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isSmall', 'customStyles', 'height', 'multi'].includes(prop),
})<DataWrapperProps>`
  /* top: ${({isSmall, multi, height}) => multi ? `${height + 7}px` : isSmall ? '31px' : '70px'}; */
  /* bottom: 0px; */
  /* top:auto; */
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 15;
  border-radius: ${({theme}) => theme.radius.control};
  overflow-y: auto;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 2px 2px ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[400]};
    border-width: 0 2px 0 2px;
    border-color: rgba(28,28,28,0);
    border-style: solid;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track {
    margin: 12px 0 12px 0;
  }
  ::-webkit-scrollbar-button{
    display: none;
  }
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => theme.shadows.menu};
  width: 100%;
  filter: ${({theme}) => theme.isDark ? 'drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.5));' : ''};
  max-height: 354px;
`
export const Option = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'isSmall',
})<ActiveProp>`
  box-sizing: border-box;
  width: 100%;
  height: ${({isSmall}) => isSmall ? '24px' : ''};
  display: flex;
  border-radius: ${({theme}) => theme.radius.xs};
  min-height: ${({isSmall}) => isSmall ? '24px' : '40px'};
  padding: ${({isSmall}) => isSmall ? '2px 8px 2px 10px' : '10px 8px 10px 10px'};
  color:${({theme}) => theme.grey[850]};
  background-color: ${({theme, active}) => active ? theme.grey[300] : ''};
  opacity: ${({$disabled}) => $disabled ? '0.5' : '1'};
  &:hover{
    cursor: ${({$disabled}) => $disabled ? 'not-allowed' : 'pointer'};
    background-color: ${({theme, $disabled}) => $disabled ? 'transparent' : theme.isDark ? theme.palette[200] : theme.grey[100]};
  }
  &:focus-visible{
    outline: none;
    background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};
  }
`
export const ItemTextTitle = styled(BodyDefault)<ActiveProp>`
  color:${({theme, $disabled}) => $disabled ? theme.grey[600] : theme.neutral[100]};
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  min-width: 0;
`
export const ItemText = styled(BodyDefault)`
  color:${({theme}) => theme.palette[850]};
  overflow: hidden !important;
  text-overflow: ellipsis;
`
export const ItemTextSmall = styled(BodySmall)`
  color:${({theme}) => theme.palette[850]};
`
export const PropContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: 3px 4px;
  height:21px;
  background-color: ${({theme}) => theme.palette[300]};
  border-radius: ${({theme}) => theme.radius.xs};
  align-items: center;
`
export const Prop = styled(VerySmall)`
  color:${({theme}) => theme.palette[850]};
`
export const PropMulti = styled(BodySmall)`
  color:${({theme}) => theme.palette[850]};
`
export const PropsWrapper = styled.div`
  display:flex;
  flex-wrap: wrap;
  width:100%;
  gap:6px;
`

export const SelectInput = styled.input`
  width:50px;
  height:27px;
  border:none;
  outline: none;
  color:${({theme}) => theme.base.black};
  background-color:${({theme}) => theme.palette[10]};
  font: inherit;
  &:disabled {
    color: ${({theme}) => theme.grey[600]};
    background-color: ${({theme}) => theme.palette[200]};
  }
  /* z-index: 22; */
`

export const SearchField = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 40px;
  padding: 10px;
  gap: 8px;
  background-color: ${({theme}) => theme.grey[100]};

  img {
    width: 16px;
    height: 16px;
  }
`

export const SearchInput = styled.input`
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: ${({theme}) => theme.palette[900]};
  font-family: Inter;
  font-size: 15px;
  line-height: 20px;
`

export const MultiCheck = styled.span<ActiveProp>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-right: 6px;
  border: ${({theme, $checked}) => `1px solid ${$checked ? theme.accent[100] : theme.grey[400]}`};
  border-radius: ${({theme}) => theme.radius.xs};
  background-color: ${({theme, $checked}) => $checked ? theme.accent[100] : theme.palette[10]};
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
`

export const ItemFlavor = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'block',
})<FlavorTypeItem>`
  flex-wrap:wrap;
  gap:6px;
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  opacity: ${({block}) => block ? '0.5' : ''};
`
export const Categorytitle = styled(VerySmall)`
  color:${({theme}) => theme.grey[600]};
  text-transform: uppercase;
`
